import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { PricePerMonth } from '../price/PricePerMonth';
import { jsx as _jsx } from "react/jsx-runtime";
export const AdditionalSeatsStartAtText = ({
  seatQuantityType = 'mixed',
  price,
  currencyCode,
  currencyCodeUnit
}) => {
  const PriceComponent = /*#__PURE__*/_jsx(PricePerMonth, {
    price: price,
    seleniumId: seatQuantityType,
    currencyCode: currencyCode,
    currencyCodeUnit: currencyCodeUnit,
    showPricePerMonthPerSeat: false
  });
  switch (seatQuantityType) {
    case 'SALES_SEAT':
      return /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "seatsComponents.additionalSeatsStartAt.sales",
        options: {
          price: PriceComponent
        }
      });
    case 'SERVICE_SEAT':
      return /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "seatsComponents.additionalSeatsStartAt.service",
        options: {
          price: PriceComponent
        }
      });
    case 'CORE_SEAT':
      return /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "seatsComponents.additionalSeatsStartAt.core",
        options: {
          price: PriceComponent
        }
      });
    default:
      return /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "seatsComponents.additionalSeatsStartAt.mixed",
        options: {
          price: PriceComponent
        }
      });
  }
};